module.exports = __webpack_public_path__ + "static/media/R2.b5ed3836.png";